import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="text-xs font-semibold uppercase tracking-wider text-primary-600 whitespace-nowrap">Browse Categories</span>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mt-3 mb-3">
            Superbuy Spreadsheet Categories
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            Explore our comprehensive product categories. Each category links to detailed product listings on our main platform.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat, idx) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative flex flex-col items-center justify-center p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/60 hover:border-primary-200 hover:bg-background-100 transition-all duration-200 cursor-pointer"
            >
              <span className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-50 text-primary-600 group-hover:bg-primary-100 group-hover:scale-110 transition-all duration-200 mb-3">
                <i className={`${cat.icon} text-lg md:text-xl`}></i>
              </span>
              <span className="text-xs md:text-sm font-medium text-foreground-800 text-center whitespace-nowrap">
                {cat.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}